import {NorthAmericaDifficultyLevel} from "./types";

import {GAME_NORTH_AMERICA} from "../../../Games";
import {Game} from "../../../types";
import {StringUtil} from "../../../../shared/string_util";
import {$KTS} from "../../../../shared/types";
import {MapGameFragment} from "../MapGameFragment";
import {ReactComponent as NorthAmericaMap} from "../res/north_america.svg";
import {Component} from "react";
import {Country, NORTH_AMERICA_COUNTRIES} from "../types";

export class NorthAmericaGameFragment extends MapGameFragment<NorthAmericaDifficultyLevel> {

  protected getGame(): Game {
    return GAME_NORTH_AMERICA;
  }

  protected allCountries(): Country[] {
    return NORTH_AMERICA_COUNTRIES;
  }

  protected getMapComponent(): typeof Component {
    //@ts-ignore
    return NorthAmericaMap;
  }

  protected getLevels(): NorthAmericaDifficultyLevel[] {
    return NorthAmericaDifficultyLevel.VALUES;
  }

  protected getResultText(): string {
    let resultText: string = "You completed %{level} game.";
    switch (this.state.gameConfig.level) {
      case NorthAmericaDifficultyLevel.MEDIUM:
        resultText = StringUtil.format(resultText, $KTS("level", "a medium"));
        break;
    }
    return resultText;
  }
}